function ensurePcFormErrorContainer(form) {
  let container = form.querySelector('#pc_form_error');
  if (!container) {
    container = document.createElement('div');
    container.id = 'pc_form_error';
    form.insertBefore(container, form.firstChild);
  }
  return container;
}

function renderPcFormError(form, message) {
  const container = ensurePcFormErrorContainer(form);
  container.innerHTML = '';
  if (!message) return;

  const alert = document.createElement('div');
  alert.className = 'fr-alert fr-alert--error fr-alert--sm fr-mb-2w';
  alert.setAttribute('role', 'alert');

  const paragraph = document.createElement('p');
  paragraph.textContent = message;
  alert.appendChild(paragraph);

  container.appendChild(alert);
}

function isPdfFile(file) {
  if (!file) return false;
  const hasPdfMimeType = file.type === 'application/pdf';
  const hasPdfExtension = file.name.toLowerCase().endsWith('.pdf');
  return hasPdfMimeType || hasPdfExtension;
}

function formatBytes(bytes) {
  if (!Number.isFinite(bytes) || bytes < 0) return '0 B';
  if (bytes < 1024) return `${bytes} B`;

  const units = ['KB', 'MB', 'GB'];
  let value = bytes / 1024;
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  return `${value.toFixed(2)} ${units[unitIndex]}`;
}

function initPermisConsolidePdfUpload() {
  const forms = document.querySelectorAll('[data-pc-pdf-upload-form="true"]');
  if (!forms.length) return;

  forms.forEach((form) => {
    const fieldGroup = form.querySelector('.fr-upload-group');
    const input = form.querySelector('input[name="permis_consolide[pdf_file]"]');
    const inlineError = form.querySelector('#pc_pdf_file_error');
    if (!input) return;

    const maxSizeBytes = Number(form.dataset.pcMaxPdfSizeBytes || '0');
    const tooLargeMessage = form.dataset.pcErrorTooLarge;
    const invalidMessage = form.dataset.pcErrorInvalid;
    const uploadFailedMessage = form.dataset.pcErrorUploadFailed;
    const requiredMessage = form.dataset.pcErrorRequired;

    const buildTooLargeMessage = () => {
      const file = input.files?.[0];
      if (!file) return tooLargeMessage || uploadFailedMessage;
      return `${tooLargeMessage || uploadFailedMessage} (${file.name}: ${formatBytes(file.size)})`;
    };

    const renderFieldError = (message) => {
      if (message) {
        input.setAttribute('aria-invalid', 'true');
        fieldGroup?.classList.add('fr-input-group--error');
        input.classList.add('fr-upload--error');
      } else {
        input.removeAttribute('aria-invalid');
        fieldGroup?.classList.remove('fr-input-group--error');
        input.classList.remove('fr-upload--error');
      }

      if (!inlineError) return;
      inlineError.textContent = message || '';
      inlineError.classList.toggle('fr-hidden', !message);
    };

    const validateSelectedFile = ({ showRequiredMessage = false } = {}) => {
      const file = input.files?.[0];
      if (!file) {
        if (showRequiredMessage && input.required) {
          const message = requiredMessage || invalidMessage || uploadFailedMessage || 'Invalid file';
          input.setCustomValidity(message);
          renderFieldError(message);
          return false;
        }

        input.setCustomValidity('');
        renderFieldError(null);
        renderPcFormError(form, null);
        return true;
      }

      if (!isPdfFile(file)) {
        input.setCustomValidity(invalidMessage || uploadFailedMessage || 'Invalid file');
        renderFieldError(input.validationMessage);
        renderPcFormError(form, invalidMessage);
        return false;
      }

      if (maxSizeBytes > 0 && file.size > maxSizeBytes) {
        const tooLargeFileMessage = buildTooLargeMessage();
        input.setCustomValidity(tooLargeFileMessage);
        renderFieldError(input.validationMessage);
        renderPcFormError(form, tooLargeFileMessage);
        return false;
      }

      input.setCustomValidity('');
      renderFieldError(null);
      renderPcFormError(form, null);
      return true;
    };

    input.addEventListener('change', validateSelectedFile);
    input.addEventListener('input', () => validateSelectedFile());

    form.addEventListener('submit', (event) => {
      if (!validateSelectedFile({ showRequiredMessage: true })) {
        event.preventDefault();
      }
    });

    form.addEventListener('turbo:submit-end', (event) => {
      const status = event.detail?.fetchResponse?.response?.status;
      if (status === 413) {
        renderPcFormError(form, buildTooLargeMessage());
        return;
      }

      if (!event.detail.success && status && status >= 400) {
        const hasInlineError = form.querySelector('#pc_form_error .fr-alert');
        if (!hasInlineError) renderPcFormError(form, uploadFailedMessage);
      }
    });

    // Keep the user on the form when proxy/app returns an error page (e.g. 413),
    // otherwise Turbo navigation can wipe the inline error immediately.
    form.addEventListener('turbo:before-fetch-response', (event) => {
      const status = event.detail?.fetchResponse?.response?.status;
      if (status === 413) {
        event.preventDefault();
        renderPcFormError(form, buildTooLargeMessage());
        return;
      }

      if (status && status >= 500) {
        event.preventDefault();
        renderPcFormError(form, uploadFailedMessage);
      }
    });

    form.addEventListener('turbo:fetch-request-error', (event) => {
      event.preventDefault();
      renderPcFormError(form, uploadFailedMessage);
    });
  });
}

document.addEventListener('turbo:load', initPermisConsolidePdfUpload);
document.addEventListener('DOMContentLoaded', initPermisConsolidePdfUpload);
